module.exports = __webpack_public_path__ + "static/media/Reostat_white.ef72ec66.svg";